export default "__VITE_ASSET__Nyoccb3x__"